/**
 * Create an svg icon
 */
export function makeSvgIcon({ className = '', path = '', size = '24', viewBox = '0 0 18 19' }) {
  return `
    <svg xmlns="http://www.w3.org/2000/svg" class="${className}" width="${size}" height="${size}" viewBox="${viewBox}">
      ${path}
    </svg>
  `;
}
